export default {
  lines_all: state => {
    return state.lines_all;
  },
  expandingNavItems: state => state.expandingNavItems
}
